function checkout_redirect() {
  $('.btn-buynow').on('click', function (e) {
    e.preventDefault();

    const $btn = $(this);
    const variantId = $btn.data('variant-id');
    const sellingPlanId = $btn.data('selling-plan-id');
    const purchaseType = $btn.data('purchase-type') || 'one-time';
    const quantity = parseInt($btn.data('quantity'), 10) || 1;

    const addParams = new URLSearchParams();
    addParams.append('items[][id]', String(variantId));
    addParams.append('items[][quantity]', String(Number.isFinite(quantity) && quantity > 0 ? quantity : 1));

    if (purchaseType === 'subscription') {
      addParams.append('items[][selling_plan]', String(sellingPlanId));
    }

    const discount = `GREENJUICE${quantity}ONETIME`;

    const returnTo = `/cart/add?${addParams.toString()}&return_to=/checkout?discount=${discount}`;

    const clearUrl = new URL('/cart/clear', window.location.origin);
    clearUrl.searchParams.set('return_to', returnTo);

    window.location.href = clearUrl.toString();
  });
}

$(window).on('load', checkout_redirect);
